import React, { useEffect, useState } from 'react'
import Layout from './layout'
import Subpages from './public/subpages'
import useMediaQuery from '../hooks/useMediaQuery'
import { Link, useLocation, useParams } from 'react-router-dom'
import { BASE_URL, getNewList, getYear } from '../api/api'
import Pagination from './pagination'
import NavLink from './navLink'

const LjhdList = () => {
  const isMobile = useMediaQuery()
  const { channel_id = 1, page = 1 } = useParams()
  const pagesize = 20
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const year = searchParams.get('year')

  const [data, setData] = useState([])
  const [title2, setTitle2] = useState('')

  useEffect(() => {
    getNewList(
      `archives/newsList?pagesize=${pagesize}&channel_id=${channel_id}&page=${page}&year=${year}`.replace(
        '.html',
        ''
      )
    ).then(res => {
      setData(res?.data)
    })
    getYear(`index/getYear?year=${year}`).then(res => {
      setTitle2(res?.data?.title)
    })
  }, [pagesize, channel_id, page, year])

  return (
    <Layout>
      <Subpages className="px-5 lg:px-0 mb-10 lg:mb-0" name="历届活动" title2={title2}>
        <div className="flex flex-col lg:flex-row justify-between flex-wrap">
          {data?.list?.data?.map(({ id, title, image = '' }) => (
            <a
              target="_blank"
              className="max-w-[273px]"
              href={`/wzxq/id/${id}`}
              key={id}
              rel="noreferrer"
            >
              <img
                className="mt-[30px]"
                src={`${BASE_URL}${image}`}
                style={{ width: isMobile ? '100%' : 273, height: 180 }}
                alt=""
              />
              <p className="text-left mt-4 font-sourceHan text-[#333333]">{title}</p>
            </a>
          ))}
          <div className="w-[273px]"></div>
          <div className="w-[273px]"></div>
        </div>
        <Pagination
          count={data?.list?.total}
          pagesize={pagesize}
          page={data?.list?.current_page}
          totalPage={data?.list?.last_page}
        />
      </Subpages>
    </Layout>
  )
}

export default LjhdList
